import { render, staticRenderFns } from "./StylizationDetails.vue?vue&type=template&id=1c137e52&scoped=true"
import script from "./StylizationDetails.vue?vue&type=script&lang=ts"
export * from "./StylizationDetails.vue?vue&type=script&lang=ts"
import style0 from "./StylizationDetails.vue?vue&type=style&index=0&id=1c137e52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c137e52",
  null
  
)

export default component.exports